import React from "react";
import { PromptModal } from "@/components/Common/PromptModal";
import { ConfirmationModalProps, useConfirmationModal } from "@/hooks/useConfirmationModal";

export const useDeleteLanguageConfirmationModal = () => {
    const { ConfirmationModal, confirm } = useConfirmationModal<boolean, DeleteLanguageModalProps>(
        DeleteLanguageConfirmationModal,
    );

    return {
        DeleteWindowConfirmationModal: ConfirmationModal,
        confirmDeleteLanguage: confirm,
    };
};

interface DeleteLanguageModalProps {
    language?: string;
}

const DeleteLanguageConfirmationModal = ({
    isOpen,
    onClose,
    onContinue,
    language,
}: ConfirmationModalProps<boolean, DeleteLanguageModalProps>) => {
    return (
        <PromptModal
            title="Delete Language"
            isOpen={isOpen}
            dialogText={{ secondary: "Cancel", submit: "Delete" }}
            onConfirm={onContinue}
            onClose={onClose}
        >
            <span>All translated content for {language} will be deleted. Are you sure you want to proceed?</span>
        </PromptModal>
    );
};
